<template>
  <div>
    <PageHeadingText :title="publisherAsset" />
    <template v-for="substructure in structure" :key="substructure.id">
      <Root
        v-bind="{
          structure: substructure,
          customProperties:
            substructure.data && substructure.data.customProperties,
          title: publisherAsset,
          img:
            substructure.data.customProperties[publisherAsset.toLowerCase()] ||
            null,
          background:
            substructure.data.customProperties[
              `${publisherAsset.toLowerCase()}-background`
            ] || null,
        }"
      ></Root>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { mcpIsNaN, bindTabName, hasEntries } from '@/api/utils';
import { onMounted, computed } from 'vue';
import PageHeadingText from '~/components/shared/PageHeadingText.vue';
const { $globals, $api, $customGtm } = useNuxtApp();
const route = useRoute();

const { data, error } = await useAsyncData(async () => {
  const payload = {} as { [key: string]: string };
    if (mcpIsNaN(+route.params.name)) {
      payload.publisher = route.params.name.toString().replaceAll('-', ' ');
    }
    const structure = await $api.endPoints.getStructure(
      'pages_games_publisher',
      payload,
    );

    if (!hasEntries(structure)) {
      throw 'there is no entries';
    }

    return { structure };
});
if (error?.value) {
  throw createError({ statusCode: 404, message: 'Not Found' });
}

const publisherAsset = computed(() => {
  return route.params.name.toString().replaceAll('-', ' ');
}).value;
const structure = data?.value?.structure;
useHead({
  title: bindTabName({
    title: publisherAsset,
    vertical: $globals.tabNameSeo.gamesVertical,
    prefix: $globals.tabNameSeo.gamesPrefix,
  }),
});

onMounted(() => {
  $customGtm.track({
    EN: 'page_view',
    PT: 'View Game Publisher Page',
    PC: 'Game Publisher Page',
  });
});
</script>
<style lang="scss" scoped>
:deep() {
  .hero-banner-bg {
    > .v-image__image {
      height: 500px;
      @media #{map-get($display-breakpoints, 'md-and-up')} {
        height: 100%;
      }
    }
  }
}
</style>
